import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/dist/query/react';
import type { BaseQueryFn } from '@reduxjs/toolkit/src/query';
import { env } from 'next-runtime-env';

import { retentionTags } from '~shared/api/retention/names';

import type { RetentionPopupResponse } from './types';

const liveApiFallback = 'https://api.winemback.com/';

const retentionBaseQuery: BaseQueryFn = async (args, api, extraOptions) => {
	return fetchBaseQuery({
		baseUrl: env('NEXT_PUBLIC_RETENTION_API') ?? liveApiFallback,
	})(args, api, extraOptions);
};

export const retentionApi = createApi({
	reducerPath: 'retentionApi',
	baseQuery: retentionBaseQuery,
	endpoints: (build) => ({
		popupConfig: build.query<
			RetentionPopupResponse,
			{ userId: string; jwt: string }
		>({
			query: ({ userId, jwt }) => ({
				url: `/contacts/${userId}/popup/messages`,
				method: 'GET',
				headers: {
					Authorization: `External jwt="${jwt}"`,
				},
			}),
			providesTags: (_, __, arg) => [
				{ type: retentionTags.popup, id: arg.userId },
			],
		}),
		deleteConfig: build.mutation<unknown, { userId: string; jwt: string }>({
			query: ({ userId, jwt }) => ({
				url: `/contacts/${userId}/popup/messages`,
				method: 'DELETE',
				headers: {
					Authorization: `External jwt="${jwt}"`,
				},
			}),
			invalidatesTags: (_, __, args) => [
				{ type: retentionTags.popup, id: args.userId },
			],
		}),
	}),
	tagTypes: [retentionTags.popup],
});
